import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Tooltip from "@material-ui/core/Tooltip";
import useCalEmbed from "./useCalEmbed";

const BANNER_HEIGHT = 48;

const useBannerStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    height: BANNER_HEIGHT,
    backgroundColor: "#ffd54f",
    color: "#4e342e",
    padding: theme.spacing(1.5),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1250,
    transition: "transform 0.3s ease-in-out",
    transform: (props) => (props.open ? "translateY(0)" : "translateY(-100%)"),
    boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.2)",
  },
  text: {
    fontWeight: 500,
    marginRight: theme.spacing(2),
    fontSize: "0.875rem",
  },
  button: {
    backgroundColor: "#5d4037",
    color: "white",
    fontWeight: 600,
    fontSize: "0.75rem",
    padding: "4px 12px",
    "&:hover": {
      backgroundColor: "#3e2723",
    },
  },
  closeBtn: {
    position: "absolute",
    right: theme.spacing(1),
    color: "#4e342e",
  },
}));

const StickyBanner = ({ open, onClose, handleScheduleCallCloseAll }) => {
  const classes = useBannerStyles({ open });

  useCalEmbed(open, handleScheduleCallCloseAll);

  return (
    <div id="sticky-banner" className={classes.root}>
      <Typography className={classes.text}>
        Book a quick call with our specialists for a free consultation
      </Typography>
      <Button
        variant="contained"
        size="small"
        className={classes.button}
        data-cal-link="pandiri-auphees-juq3kz/20-min-meeting"
        data-cal-config='{"theme":"light","layout":"month_view"}'
      >
        Book Now
      </Button>

      <Tooltip title="Dismiss Permanently" arrow placement="bottom">
        <IconButton
          size="medium"
          className={classes.closeBtn}
          onClick={onClose}
          aria-label="Close banner"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default StickyBanner;